import type { FunctionComponent } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { Description } from "@/modules/jobSearchPrefiltered/components/PrefilteredAside/Description/Description"
import { NetlinkingBlocks } from "@/modules/jobSearchPrefiltered/components/PrefilteredAside/NetlinkingBlocks/NetlinkingBlocks"
import { TITLE_TRANSLATION_KEY_PER_TYPE } from "@/modules/jobSearchPrefiltered/constants"
import { useContent } from "@/modules/jobSearchPrefiltered/hooks/useContent"
import { getLocalizedContentKeysForSlug } from "@/modules/jobSearchPrefiltered/utils/getLocalizedContentKeysForSlug"

type PrefilteredAsideProps = {
  jobAdTotalSize: number
}

export const PrefilteredAside: FunctionComponent<PrefilteredAsideProps> = ({ jobAdTotalSize }) => {
  const { data: contentData } = useContent()
  const { t } = useTranslation(["job_search_prefiltered"])

  if (!contentData) {
    return null
  }

  const { description } = getLocalizedContentKeysForSlug(contentData.currentSlug)

  const netlinkingBlocks = contentData.netlinkingBlocks.map(netlinkingBlock => {
    const availableSlugs = netlinkingBlock.slugs.map(slug => {
      const { title } = getLocalizedContentKeysForSlug(slug)

      return { ...slug, titleTranslation: t(title, slug.params) }
    })

    return {
      ...netlinkingBlock,
      availableSlugs,
      netlinkingBlockLabel: t(TITLE_TRANSLATION_KEY_PER_TYPE[netlinkingBlock.type], contentData.currentSlug.params),
      seeMoreLabel: t("job_search_prefiltered.netlinking_block.see_more"),
    }
  })

  return (
    <>
      <Description
        titleLabel={t("job_search_prefiltered.description_block.title")}
        descriptionLabel={t(description, { ...contentData.currentSlug.params, count: jobAdTotalSize })}
      />
      <NetlinkingBlocks netlinkingBlocks={netlinkingBlocks} />
    </>
  )
}
